import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CardFooterComponent } from '../../../shared/card-footer/card-footer.component';
import { HeaderComponent } from '../../../shared/header/header.component';
import { EmployeeAuthService } from '../../../shared/services/employee-auth.service';
import { ErrorMessageService } from '../../../shared/services/error-message.service';

@Component({
  selector: 'app-password',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    HeaderComponent,
    CardFooterComponent,
    TranslateModule,
  ],
  templateUrl: './password.component.html',
  styleUrl: './password.component.css',
})
export class PasswordComponent implements OnInit {
  passwordForm: FormGroup;
  isLoading = false;
  errorMessage = '';

  constructor(
    private titleService: Title,
    private translate: TranslateService,
    private employeeAuthService: EmployeeAuthService,
    private router: Router,
    private fb: FormBuilder,
    private errorMessageService: ErrorMessageService
  ) {
    this.passwordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
    this.translate.onLangChange.subscribe(() => {
      this.updateTitle();
    });
    this.updateTitle();
  }

  updateTitle(): void {
    this.translate.get('EMPLOYEE.PASSWORD.TITLE').subscribe((res: string) => {
      this.titleService.setTitle(res);
    });
  }

  onSubmit(): void {
    if (this.passwordForm.invalid) {
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    const email = this.passwordForm.get('email')?.value;

    this.employeeAuthService.initiateForgotPassword(email).subscribe({
      next: (response) => {
        this.isLoading = false;
        if (this.errorMessageService.isSuccessResponse(response) && response.data) {
          const sessionData = {
            sessionId: response.data.sessionId,
            trxId: response.data.trxId,
            email: email,
          };
          sessionStorage.setItem('employeeSessionData', JSON.stringify(sessionData));
          this.router.navigate(['/employee/account/verify'], { queryParams: { type: 'employee-password-reset' } });
        } else {
          this.errorMessageService.getErrorMessage(response.errorCode).subscribe(message => {
            this.errorMessage = message;
          });
        }
      },
      error: (error) => {
        this.isLoading = false;
        if (error.error && error.error.errorCode) {
          this.errorMessageService.getErrorMessage(error.error.errorCode).subscribe(message => {
            this.errorMessage = message;
          });
        } else {
          this.translate.get('error.internalServerError').subscribe(message => {
            this.errorMessage = message;
          });
        }
      }
    });
  }
}
